(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/fractiongames/assets/react/fractiongames-app.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/fractiongames/assets/react/fractiongames-app.js');

'use strict';

const _svs$numbergames = svs.numbergames,
  FractiongamesBanner = _svs$numbergames.FractiongamesBanner,
  productMapping = _svs$numbergames.productMapping;
const FractionGamesProvider = svs.numbergames.fractiongames.redux.FractionGamesProvider;
const Fractiongames = svs.eurojackpot.components.fractiongames.Fractiongames;
const FractiongamesApp = () => React.createElement(React.Fragment, null, React.createElement(FractiongamesBanner, null), React.createElement(FractionGamesProvider, null, React.createElement(Fractiongames, {
  productFilter: productMapping.CONSTANTS.EUROJACKPOT
})));
svs.eurojackpot.components.fractiongames.FractiongamesApp = FractiongamesApp;

 })(window);